var map = {
	"./01_screen_de.svg": 29818,
	"./01_screen_en.svg": 63570,
	"./02_screen_de.svg": 77541,
	"./02_screen_en.svg": 16445,
	"./03_screen_de.svg": 62852,
	"./03_screen_en.svg": 9608,
	"./04_screen_de.svg": 81471,
	"./04_screen_en.svg": 29051,
	"./05_screen_de.svg": 53798,
	"./05_screen_en.svg": 74718,
	"./06_screen_de.svg": 74721,
	"./06_screen_en.svg": 57065
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88206;